import { VehicleDetailsContainer } from '@makemydeal/dr-activities-vehicle-details';
import { useHasVehicleDetailsLoaded } from '../../../hooks/useHasVehicleDetailsLoaded';
import { useShowroomLoadingIndicatorDisappearsTelemetry } from '../../../hooks/useShowroomLoadingIndicatorDisappearsTelemetry';

const VehicleDetails = () => {
    const hasLoaded = useHasVehicleDetailsLoaded();
    useShowroomLoadingIndicatorDisappearsTelemetry('SC:VdpLoadingIndicatorDisappears', hasLoaded);

    return <VehicleDetailsContainer />;
};

export default VehicleDetails;
